<script setup>
import { useRequestsStore } from "@/stores/storeRequests";
import { useModals } from "@/utils/useModals";

const { openModal } = useModals();

const storeRequests = useRequestsStore();
</script>
<template>
	<div class="user-data">
		<div class="user-data__contacts">
			<h3 class="user-data__title">{{ storeRequests.userData?.first_name }} {{ storeRequests.userData?.last_name }}</h3>
			<span>{{ storeRequests.userData?.email }}</span>
			<span>{{ storeRequests.userData?.phone_number }}</span>
		</div>
		<div class="user-data__btns">
			<button @click="openModal('changeUserPassword')" class="user-data__btn">Сменить пароль</button>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.user-data {
	display: flex;
	justify-content: space-between;
	background: #f9f9f9;
	padding: 2rem 2.8rem;
	gap: 2rem;
	@media (max-width: vars.$xx) {
		flex-direction: column;
	}
	@media (max-width: vars.$x480) {
		gap: 3rem;
		padding: 1.6rem 2rem;
	}
}
.user-data__title {
	font-family: var(--font-family-md);
	font-weight: 500;
	font-size: 2rem;
	line-height: 120%;
}
.user-data__contacts {
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	@media (max-width: vars.$x425) {
		gap: 0.5rem;
	}
	span {
		font-weight: 400;
		font-size: 1.4rem;
		line-height: 120%;
		color: rgba(0, 0, 0, 0.8);
	}
}
.user-data__btns {
}
.user-data__btn {
	font-weight: 400;
	font-size: 1.4rem;
	line-height: 120%;
	color: var(--red);
    border-bottom: 1px solid transparent;
	transition: var(--transition) ease-in;
	@media (max-width: vars.$x480) {
	}
	@media (hover: hover) {
		&:hover {
            border-color: currentColor;
		}
	}
}
</style>
